import script from "./resume.vue?vue&type=script&setup=true&lang=js"
export * from "./resume.vue?vue&type=script&setup=true&lang=js"

import "./resume.vue?vue&type=style&index=0&id=37934df9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37934df9"]])

export default __exports__